/**
 * Fichier d'aide pour la gestion des endpoints API
 */

// Le préfixe est entièrement géré par la variable d'environnement VITE_APP_API_URL
// et la configuration baseURL d'axios.
// const API_PREFIX: string = '/api/v1';

/**
 * Prépare un endpoint API. Le préfixe est géré par la baseURL d'axios.
 * @param {string} endpoint - Chemin relatif de l'endpoint.
 * @returns {string} - URL de l'endpoint.
 */
export const createEndpoint = (endpoint: string): string => {
  // On retourne simplement l'endpoint. Axios le combinera avec la baseURL.
  // Nettoyer un slash au début évite les problèmes si l'endpoint est accidentellement absolu.
  return endpoint.startsWith("/") ? endpoint.substring(1) : endpoint;
};
